import * as tslib_1 from "tslib";
import { MatDialogRef } from '@angular/material/dialog';
import { FuseTranslationLoaderService } from '../../../../@fuse/services/translation-loader.service';
import { sentry } from '../../../../sentry';
import { CustomMessagesService } from '../../errors/custom-messages.service';
import { delay } from '../../utils/delay';
import { ArchiveLocationEnvironmentApi } from './archive-location-environment.api';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var ArchiveEnvironmentDialogComponent = /** @class */ (function () {
    function ArchiveEnvironmentDialogComponent(data, matDialogRef, fuseTranslationLoaderService, archiveLocationSectorApi, messageService) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.archiveLocationSectorApi = archiveLocationSectorApi;
        this.messageService = messageService;
        this.selected = null;
        this.isLoading = false;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    ArchiveEnvironmentDialogComponent.prototype.updateArchived = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, err_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 6, 7, 8]);
                        this.isLoading = true;
                        if (!this.data.archived) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all([
                                this.archiveLocationSectorApi.unarchive(this.prepareUnarchivePayload()),
                                delay(1000)
                            ])];
                    case 1:
                        _c.sent();
                        this.messageService.success('ARCHIVE_ENVIRONMENT_DIALOG.UNARCHIVE.SUCCESS');
                        return [3 /*break*/, 5];
                    case 2:
                        _b = (_a = Promise).all;
                        return [4 /*yield*/, this.archiveLocationSectorApi.archive(this.prepareArchivePayload())];
                    case 3: return [4 /*yield*/, _b.apply(_a, [[
                                _c.sent(),
                                delay(1000)
                            ]])];
                    case 4:
                        _c.sent();
                        this.messageService.success('ARCHIVE_ENVIRONMENT_DIALOG.ARCHIVE.SUCCESS');
                        _c.label = 5;
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        err_1 = _c.sent();
                        sentry.captureException(err_1);
                        this.messageService.error('UNKNOWN_ERROR');
                        return [3 /*break*/, 8];
                    case 7:
                        this.matDialogRef.close({ reload: true });
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ArchiveEnvironmentDialogComponent.prototype.prepareArchivePayload = function () {
        return {
            id: this.data.sectorId,
            archiveEquipments: this.selected === 'ARCHIVE_ENVIRONMENTS_AND_EQUIPMENTS',
        };
    };
    ArchiveEnvironmentDialogComponent.prototype.prepareUnarchivePayload = function () {
        return {
            id: this.data.sectorId,
            unarchiveEquipments: this.selected === 'UNARCHIVE_ENVIRONMENTS_AND_EQUIPMENTS',
        };
    };
    return ArchiveEnvironmentDialogComponent;
}());
export { ArchiveEnvironmentDialogComponent };
